<template>
  <div class="digital-services-page" aria-label="Serviços Digitais Omint">
    <div class="ambient-shape shape-a" aria-hidden="true" />
    <div class="ambient-shape shape-b" aria-hidden="true" />

    <header class="topbar reveal">
      <div class="topbar-inner">
        <a class="brand" href="#"
aria-label="Omint">
          <img src="https://omint.app.br/images/omint/logo-omint-app.png" alt="Omint" />
          <span>Serviços Digitais</span>
        </a>
      </div>
    </header>

    <section class="hero">
      <div class="hero-card reveal delay-1">
        <h1>Serviços Digitais Omint para Associados</h1>
        <p>
          Acesso integrado por aplicativo, site e WhatsApp com a combinação entre tecnologia, segurança e cuidado
          humano.
        </p>
        <div class="hero-meta">
          <span class="pill">App Omint</span>
          <span class="pill">Site Omint</span>
          <span class="pill">WhatsApp Omint</span>
          <span class="pill">Experiência Premium</span>
        </div>
      </div>
    </section>

    <main class="content-wrap">
      <article class="content-card reveal delay-2">
        <div class="content-header">Documento institucional | Versão web</div>
        <div id="content" class="prose">
          <blockquote>
            <p><strong>Tecnologia para simplificar. Pessoas para cuidar. Processos para garantir.</strong></p>
          </blockquote>

          <p>
            Os serviços digitais Omint foram desenvolvidos para oferecer mais autonomia, agilidade e segurança aos
            associados, sem abrir mão do cuidado humano, da personalização e da experiência premium que fazem parte do
            DNA Omint.
          </p>

          <p>
            Pelo <strong>App Omint</strong>, <strong>Site Omint</strong> e <strong>WhatsApp Omint</strong>, o associado
            pode acessar serviços do plano de saúde, iniciar solicitações, acompanhar protocolos, receber alertas,
            consultar informações importantes e contar com apoio humano sempre que precisar.
          </p>

          <p>
            A tecnologia ajuda a resolver o que pode ser feito de forma mais rápida, simples e digital. E, quando a
            situação exige orientação, acolhimento ou análise personalizada, a equipe de Atendimento e Concierge Omint
            está disponível para apoiar toda a jornada.
          </p>

          <hr />

          <h2>Uma experiência digital integrada: App, Site e WhatsApp</h2>

          <p>Os canais digitais Omint funcionam de forma integrada para facilitar o dia a dia dos associados.</p>

          <p>
            Com login único, o associado pode acessar o App, o Site e o WhatsApp com segurança e utilizar os principais
            serviços do plano de saúde de forma simples, intuitiva e rastreável.
          </p>

          <p>Entre os principais benefícios da experiência digital Omint estão:</p>

          <ul>
            <li>
              Acesso aos serviços pelo <strong>App Omint</strong>, <strong>Site Omint</strong> e
              <strong>WhatsApp Omint</strong>.
            </li>
            <li>Login único para os canais digitais.</li>
            <li>Solicitações com número de protocolo.</li>
            <li>Acompanhamento integrado de demandas em andamento.</li>
            <li>Alertas e atualizações pelo aplicativo, site e WhatsApp.</li>
            <li>Histórico de solicitações disponível na área restrita.</li>
            <li>Apoio da equipe Omint sempre que necessário.</li>
            <li>Segurança, sigilo e personalização no acesso às informações pessoais.</li>
          </ul>

          <p>
            O objetivo é que o associado consiga resolver suas necessidades com autonomia, previsibilidade e
            transparência, mantendo sempre a possibilidade de contar com atendimento humano.
          </p>

          <hr />

          <h2>O que você pode fazer pelos canais digitais Omint</h2>

          <p>
            Pelos canais digitais Omint, o associado pode acessar uma ampla variedade de serviços relacionados ao plano
            de saúde, incluindo:
          </p>

          <ul>
            <li>Consultar a <strong>credencial digital</strong> e o <strong>token de atendimento</strong>.</li>
            <li>Buscar médicos, clínicas, hospitais, laboratórios e outros serviços da rede credenciada.</li>
            <li>Utilizar a <strong>busca de rede com Inteligência Artificial</strong>.</li>
            <li>Solicitar e acompanhar <strong>reembolsos</strong>.</li>
            <li>Solicitar e acompanhar <strong>autorizações prévias</strong>.</li>
            <li>Consultar análises de cobertura.</li>
            <li>Agendar e realizar teleatendimentos.</li>
            <li>Acessar programas de saúde e qualidade de vida.</li>
            <li>Solicitar concierge de medicamentos, quando disponível no plano.</li>
            <li>Consultar modelo, simulação e extrato de coparticipação.</li>
            <li>Acessar documentos importantes do plano.</li>
            <li>Emitir vouchers, quando disponíveis.</li>
            <li>Consultar faturas, extratos e documentos para Imposto de Renda.</li>
            <li>Gerenciar dados cadastrais, conta corrente e preferências de acesso.</li>
            <li>Compartilhar ou restringir informações com familiares e terceiros autorizados.</li>
          </ul>

          <p>
            Cada serviço foi pensado para reduzir burocracias, aumentar a transparência e facilitar o acesso ao cuidado.
          </p>

          <hr />

          <h2>Credencial digital e token de atendimento</h2>

          <p>
            A credencial digital Omint fica disponível no aplicativo para facilitar o atendimento na rede credenciada.
          </p>

          <p>
            O associado pode acessar as credenciais digitais das pessoas do seu grupo familiar e dos produtos
            contratados, inclusive com token de atendimento. Em situações em que não houver conexão com a internet, a
            credencial e o token podem continuar disponíveis no aplicativo, aumentando a segurança no momento do
            atendimento.
          </p>

          <p>
            A credencial também pode ser compartilhada por canais disponíveis no celular, como WhatsApp ou e-mail,
            quando necessário.
          </p>

          <p>
            Mesmo com todos os recursos digitais, caso o associado ou o prestador precise de apoio, a equipe Omint pode
            auxiliar na liberação do atendimento junto ao prestador, garantindo cuidado e segurança em situações
            excepcionais.
          </p>

          <hr />

          <h2>Busca de rede credenciada Omint</h2>

          <p>
            A busca de rede Omint foi criada para ajudar o associado a encontrar médicos, clínicas, hospitais,
            laboratórios e outros serviços de forma simples e orientada.
          </p>

          <p>
            Pelo App e pelo Site, é possível pesquisar a rede credenciada, visualizar detalhes dos prestadores e usar
            filtros para encontrar a opção mais adequada.
          </p>

          <p>A busca permite localizar serviços por critérios como:</p>

          <ul>
            <li>Especialidade ou serviço desejado.</li>
            <li>Nome do profissional, clínica ou prestador.</li>
            <li>Localização e distância.</li>
            <li>Subespecialidades.</li>
            <li>Facilidades disponíveis no local.</li>
            <li>Idiomas de atendimento.</li>
            <li>Atendimento por teleconsulta, quando disponível.</li>
            <li>Agendamento online ou por WhatsApp, quando oferecido pelo prestador.</li>
            <li>Indicação Omint.</li>
          </ul>

          <p>
            Também é possível acessar informações como endereço, telefones, rotas por aplicativos de navegação, mini
            currículo, redes sociais e outros dados fornecidos pelos prestadores.
          </p>

          <hr />

          <h2>Busca de rede com Inteligência Artificial</h2>

          <p>
            A Omint oferece uma experiência de busca de rede com apoio de Inteligência Artificial para ajudar o
            associado a encontrar o serviço adequado com mais rapidez.
          </p>

          <p>
            O associado pode escrever, falar ou incluir a imagem de um pedido médico. A Inteligência Artificial
            interpreta a necessidade e auxilia na localização dos serviços ou profissionais mais relacionados à
            solicitação.
          </p>

          <p>
            Esse recurso torna a jornada mais simples, especialmente quando o associado não sabe exatamente qual
            especialidade, exame ou prestador procurar.
          </p>

          <p>
            A busca pode ser refinada em linguagem natural, permitindo que o associado converse com o recurso digital de
            forma mais intuitiva.
          </p>

          <p>
            A Inteligência Artificial é usada para facilitar o acesso à informação e agilizar a jornada, sempre dentro
            de uma experiência segura, orientada e apoiada pelos canais de atendimento Omint.
          </p>

          <hr />

          <h2>Solicitação de indicação médica</h2>

          <p>
            Quando o associado tem dúvida sobre qual médico, especialidade ou serviço procurar, pode solicitar uma
            indicação médica pelos canais digitais Omint.
          </p>

          <p>
            A solicitação pode ser feita por mensagem, com resposta diretamente pelo App ou Site. Em algumas situações e
            para determinados contratos, também pode ser possível agendar uma teleconsulta com profissional
            especializado para apoiar a indicação.
          </p>

          <p>
            Esse serviço reforça o cuidado personalizado Omint: a tecnologia facilita o acesso, mas a orientação humana
            apoia a tomada de decisão quando o associado precisa de mais segurança.
          </p>

          <blockquote>
            <p>A disponibilidade pode variar conforme o plano ou contrato.</p>
          </blockquote>

          <hr />

          <h2>Reembolso digital Omint</h2>

          <p>A solicitação de reembolso pode ser feita de forma digital pelo App ou Site Omint.</p>

          <p>
            O associado envia os documentos necessários, acompanha o andamento da análise e consulta os detalhes do
            processo diretamente pelos canais digitais. O acompanhamento também pode ser apoiado por alertas e
            atualizações pelo WhatsApp Omint.
          </p>

          <p>A jornada digital de reembolso permite:</p>

          <ul>
            <li>Envio digital de recibos e documentos.</li>
            <li>Acompanhamento do status da solicitação.</li>
            <li>Consulta dos detalhes da análise e cálculo.</li>
            <li>Histórico de solicitações anteriores.</li>
            <li>Acesso restrito às informações pelo próprio associado.</li>
            <li>Compartilhamento de visualização apenas quando autorizado.</li>
          </ul>

          <p>
            A Omint utiliza recursos digitais e inteligência aplicada para tornar a análise mais ágil, segura e
            transparente, mantendo os cuidados necessários com auditoria, sigilo e proteção das informações pessoais.
          </p>

          <hr />

          <h2>Autorizações prévias</h2>

          <p>Alguns procedimentos precisam de autorização prévia para realização na rede credenciada.</p>

          <p>
            Pelos canais digitais Omint, o associado pode solicitar e acompanhar autorizações, consultar detalhes da
            análise e visualizar autorizações emitidas.
          </p>

          <p>
            As solicitações também podem ser feitas diretamente pelo prestador credenciado, quando aplicável, e
            acompanhadas pelo associado no App, Site ou WhatsApp.
          </p>

          <p>A jornada digital de autorizações oferece:</p>

          <ul>
            <li>Solicitação digital de autorização.</li>
            <li>Acompanhamento do status do processo.</li>
            <li>Consulta ao histórico de autorizações.</li>
            <li>Visualização de documentos relacionados.</li>
            <li>Alertas de atualização pelos canais digitais.</li>
            <li>Segurança no acesso às informações de saúde.</li>
          </ul>

          <p>
            Esse processo digital aumenta a previsibilidade e reduz a necessidade de contatos repetidos para entender o
            andamento da solicitação.
          </p>

          <hr />

          <h2>Análise de cobertura</h2>

          <p>
            Pelo App e pelo Site Omint, o associado pode consultar se determinado exame ou procedimento possui cobertura
            pelo plano e se exige autorização prévia.
          </p>

          <p>A análise pode ser feita de duas formas:</p>

          <ol>
            <li>Enviando o pedido médico para avaliação.</li>
            <li>Informando os exames ou procedimentos para obter orientação diretamente pelo canal digital.</li>
          </ol>

          <p>
            Quando algum item exigir autorização prévia, o próprio canal digital pode direcionar o associado para a
            solicitação correspondente.
          </p>

          <p>
            O histórico das análises fica disponível na área restrita do associado, preservando o sigilo das informações
            pessoais e de saúde.
          </p>

          <hr />

          <h2>Coparticipação: simulação, modelo e extrato</h2>

          <p>
            Para associados com planos que possuem coparticipação, os canais digitais Omint oferecem recursos que
            aumentam a transparência e a previsibilidade financeira.
          </p>

          <h3>Simulação de exames</h3>

          <p>
            O associado pode simular valores de coparticipação para exames, conforme os prestadores disponíveis e as
            regras do plano.
          </p>

          <p>
            A simulação ajuda a comparar opções, entender valores estimados e verificar se algum exame exige autorização
            prévia.
          </p>

          <h3>Modelo de coparticipação</h3>

          <p>
            O canal digital apresenta informações sobre o modelo de coparticipação do plano, incluindo percentuais e
            limites aplicáveis por tipo de procedimento, quando disponível.
          </p>

          <h3>Extrato de coparticipação</h3>

          <p>
            O associado pode consultar o extrato detalhado dos procedimentos considerados para desconto de
            coparticipação, além de acessar históricos anteriores.
          </p>

          <p>
            Esses recursos foram pensados para reduzir dúvidas, aumentar a transparência e apoiar o planejamento
            financeiro do associado.
          </p>

          <hr />

          <h2>Teleatendimento e Dr. Omint</h2>

          <p>
            O Dr. Omint permite agendar e realizar consultas médicas por teleatendimento pelo aplicativo ou site,
            conforme disponibilidade do serviço.
          </p>

          <p>
            Os agendamentos ficam visíveis nos canais digitais e podem ser cancelados ou remarcados pelo próprio
            associado.
          </p>

          <p>
            O associado também pode receber aviso pelo WhatsApp antes do início do atendimento, facilitando o acesso à
            consulta no horário marcado.
          </p>

          <p>
            Em horários específicos, o associado pode ser direcionado para atendimento com médicos plantonistas,
            conforme regras e disponibilidade do serviço.
          </p>

          <p>
            A equipe Omint também acompanha as informações necessárias para apoiar o associado em caso de dúvidas ou
            dificuldades no acesso.
          </p>

          <hr />

          <h2>Programas de saúde e qualidade de vida</h2>

          <p>
            Os canais digitais Omint também permitem acompanhar programas de saúde e qualidade de vida dos quais o
            associado participe.
          </p>

          <p>
            Pelo App ou Site, é possível enviar e receber mensagens da equipe responsável pelo programa, anexar imagens
            ou documentos e consultar o histórico de interações.
          </p>

          <p>Cada contato gera protocolo, reforçando a rastreabilidade, a transparência e a continuidade do cuidado.</p>

          <p>
            A equipe de Atendimento e Concierge Omint pode apoiar o associado durante a jornada, esclarecendo dúvidas e
            acompanhando necessidades específicas.
          </p>

          <hr />

          <h2>Concierge de medicamentos</h2>

          <p>
            Para planos e condições elegíveis, o Concierge de Medicamentos permite solicitar a entrega de medicamentos
            especiais cobertos pelo plano diretamente na residência do associado.
          </p>

          <p>
            O processo pode ser acompanhado pelos canais digitais durante o período em que o serviço for necessário.
          </p>

          <p>
            Esse recurso combina conveniência, cuidado e acompanhamento, reduzindo deslocamentos e facilitando o acesso
            ao tratamento.
          </p>

          <blockquote>
            <p>A disponibilidade do serviço depende das condições de cobertura do plano contratado.</p>
          </blockquote>

          <hr />

          <h2>Avaliação de prestadores</h2>

          <p>
            Após utilizar um serviço da rede credenciada, o associado pode receber um convite para avaliar sua
            experiência.
          </p>

          <p>
            As avaliações ajudam a Omint a acompanhar a qualidade da rede credenciada e aprimorar continuamente as
            indicações e a experiência dos associados.
          </p>

          <p>As informações são tratadas de forma sigilosa e utilizadas para gestão interna da qualidade.</p>

          <hr />

          <h2>WhatsApp Omint</h2>

          <p>O WhatsApp Omint é um canal digital integrado à experiência do associado.</p>

          <p>
            Por ele, é possível acessar informações, acompanhar solicitações, receber alertas e interagir com
            atendimento apoiado por Inteligência Artificial e atendimento humano.
          </p>

          <p>
            O canal pode ser acessado pelo próprio WhatsApp do associado ou por atalhos disponíveis no App e no Site.
          </p>

          <p>Entre os principais usos do WhatsApp Omint estão:</p>

          <ul>
            <li>Recebimento de alertas e atualizações de status.</li>
            <li>Acompanhamento de solicitações em andamento.</li>
            <li>Acesso a serviços digitais sem precisar iniciar a navegação pelo aplicativo ou site.</li>
            <li>Apoio em português e inglês, conforme disponibilidade.</li>
            <li>Atendimento com apoio de Inteligência Artificial e pessoas quando necessário.</li>
          </ul>

          <p>O WhatsApp complementa os demais canais digitais, oferecendo conveniência e proximidade na comunicação.</p>

          <hr />

          <h2>Documentos de apoio</h2>

          <p>O App e o Site Omint contam com área exclusiva para documentos importantes relacionados ao plano.</p>

          <p>O associado pode consultar documentos como:</p>

          <ul>
            <li>Manuais do plano.</li>
            <li>Formulários.</li>
            <li>Termos de aceite.</li>
            <li>Informes para declaração de Imposto de Renda.</li>
            <li>Documentos relacionados à utilização do plano.</li>
          </ul>

          <p>
            O acesso aos documentos respeita as regras de segurança e sigilo, garantindo que as informações sejam
            exibidas apenas para pessoas autorizadas.
          </p>

          <hr />

          <h2>Vouchers, vacinas e check-up</h2>

          <p>Alguns planos oferecem serviços específicos que também podem ser acessados pelos canais digitais Omint.</p>

          <h3>Voucher de vacina</h3>

          <p>
            Quando disponível no plano, o associado pode selecionar prestador credenciado, vacinas elegíveis e
            beneficiários que serão vacinados, emitindo o voucher pelo App ou Site.
          </p>

          <h3>Voucher de check-up</h3>

          <p>
            Quando o plano inclui check-up anual, o titular pode escolher o prestador credenciado e emitir a autorização
            digital para realização do check-up.
          </p>

          <p>
            O WhatsApp Omint pode apoiar a jornada com lembretes, ajudando o associado a não esquecer esse cuidado
            preventivo.
          </p>

          <blockquote>
            <p>A disponibilidade de vacinas e check-up depende do produto e das condições contratadas.</p>
          </blockquote>

          <hr />

          <h2>Seguro viagem</h2>

          <p>
            Para produtos que incluem Seguro Viagem, o App Omint permite consultar o guia de coberturas, emitir carta de
            seguro viagem em diferentes idiomas e acessar orientações para acionamento da cobertura.
          </p>

          <p>Também pode ser possível contratar seguro viagem complementar, conforme disponibilidade.</p>

          <p>
            O atendimento relacionado ao seguro viagem pode ser feito por WhatsApp, e-mail ou telefone, de acordo com as
            condições do serviço.
          </p>

          <hr />

          <h2>Fatura, extratos e documentos regulatórios</h2>

          <p>
            Os canais digitais Omint permitem consultar informações administrativas importantes do plano, conforme
            perfil do associado e produto contratado.
          </p>

          <p>Entre os documentos e informações disponíveis podem estar:</p>

          <ul>
            <li>Faturas mensais e faturas anteriores.</li>
            <li>Extrato de utilização da saúde suplementar.</li>
            <li>Identificação padrão da saúde suplementar.</li>
            <li>Carta de permanência.</li>
            <li>Documentos para Imposto de Renda.</li>
          </ul>

          <p>
            Esses recursos aumentam a autonomia do associado e reduzem a necessidade de contato para obtenção de
            documentos recorrentes.
          </p>

          <hr />

          <h2>Segurança, privacidade e login individual</h2>

          <p>A segurança das informações pessoais e de saúde é um ponto central da experiência digital Omint.</p>

          <p>
            Cada beneficiário possui seu próprio login e senha, permitindo acesso individualizado aos dados e serviços.
          </p>

          <p>
            O primeiro acesso pode ser realizado pelo App ou Site, com validação por biometria facial ou token enviado
            para e-mail pessoal, conforme regras de segurança aplicáveis.
          </p>

          <p>A Omint também oferece recursos como:</p>

          <ul>
            <li>Login único para App, Site e WhatsApp.</li>
            <li>Biometria facial para validação de identidade.</li>
            <li>Acesso individual por beneficiário.</li>
            <li>Proteção de informações pessoais, médicas e financeiras.</li>
            <li>Histórico de interações e solicitações.</li>
            <li>Registro de protocolos.</li>
            <li>Gestão personalizada de permissões.</li>
          </ul>

          <p>A tecnologia é usada para dar autonomia ao associado sem comprometer o sigilo de suas informações.</p>

          <hr />

          <h2>Gestão de acesso familiar e cadastro de terceiros</h2>

          <p>A Omint oferece uma experiência digital personalizada para cada pessoa do contrato.</p>

          <p>
            Por padrão, as informações pessoais não são automaticamente compartilhadas com outras pessoas do grupo
            familiar, inclusive cônjuge. O próprio associado pode definir quais informações deseja compartilhar e com
            quem.
          </p>

          <p>A gestão de acesso permite configurar permissões relacionadas a temas como:</p>

          <ul>
            <li>Reembolsos.</li>
            <li>Autorizações.</li>
            <li>Atendimentos.</li>
            <li>Informações do plano.</li>
            <li>Histórico de solicitações.</li>
          </ul>

          <p>
            Também é possível cadastrar terceiros autorizados, como familiares, secretárias ou pessoas que auxiliam
            idosos e menores, conforme regras e validações de segurança.
          </p>

          <p>
            Cada pessoa autorizada possui login próprio, validação de identidade e registro das interações realizadas.
          </p>

          <p>Esse modelo reforça a autonomia, a segurança e a personalização da experiência digital Omint.</p>

          <hr />

          <h2>Acessibilidade digital</h2>

          <p>
            A experiência digital Omint também considera recursos de acessibilidade para ampliar a autonomia dos
            associados.
          </p>

          <p>
            O Site e o App oferecem atendimento em Libras por teleatendimento, realizado com apoio de intérprete humano.
          </p>

          <p>
            Na área logada do Site, clientes com necessidades especiais podem ajustar a navegação e a apresentação das
            telas, com configurações personalizadas vinculadas ao próprio usuário.
          </p>

          <p>Esses recursos reforçam o compromisso da Omint com inclusão, autonomia e cuidado em todos os canais.</p>

          <hr />

          <h2>Atendimento Omint: digital quando facilita, humano quando importa</h2>

          <p>
            Os canais digitais Omint foram criados para facilitar o acesso aos serviços, mas não substituem o cuidado
            humano.
          </p>

          <p>
            Quando o associado precisa de orientação, apoio para utilizar os canais, esclarecimento de dúvidas ou
            atendimento em situações sensíveis, a equipe de Atendimento e Concierge Omint está disponível para ajudar.
          </p>

          <p>
            Além dos canais digitais, o atendimento telefônico Omint oferece suporte todos os dias, 24 horas por dia,
            com atendimento em português e inglês.
          </p>

          <p>A proposta é combinar:</p>

          <ul>
            <li><strong>Tecnologia</strong>, para simplificar jornadas e reduzir tempo de resposta.</li>
            <li><strong>Pessoas</strong>, para oferecer empatia, orientação e cuidado personalizado.</li>
            <li><strong>Processos</strong>, para garantir segurança, rastreabilidade e qualidade.</li>
          </ul>

          <p>Essa combinação traduz a forma Omint de cuidar: moderna, segura, próxima e personalizada.</p>

          <hr />

          <h2>Perguntas frequentes sobre os serviços digitais Omint</h2>

          <h3>O que são os serviços digitais Omint?</h3>

          <p>
            São os canais e funcionalidades digitais disponíveis para associados Omint pelo App, Site e WhatsApp. Eles
            permitem acessar serviços do plano, iniciar solicitações, acompanhar protocolos, receber alertas e consultar
            informações de forma segura e integrada.
          </p>

          <h3>Quais canais digitais a Omint oferece aos associados?</h3>

          <p>
            A Omint oferece serviços digitais pelo App Omint, Site Omint e WhatsApp Omint. Esses canais são integrados e
            permitem que o associado acompanhe sua jornada de forma mais simples e conveniente.
          </p>

          <h3>Posso usar o mesmo login no App, Site e WhatsApp Omint?</h3>

          <p>
            Sim. Os canais digitais Omint utilizam login único, oferecendo mais praticidade e segurança no acesso aos
            serviços.
          </p>

          <h3>O App Omint tem carteirinha digital?</h3>

          <p>
            Sim. O App Omint disponibiliza credencial digital e token de atendimento, inclusive para pessoas do grupo
            familiar e produtos contratados, conforme elegibilidade.
          </p>

          <h3>A credencial digital funciona sem internet?</h3>

          <p>
            O App Omint pode exibir a credencial digital e o token mesmo quando não houver conexão com a internet,
            facilitando o atendimento na rede credenciada.
          </p>

          <h3>Como encontro médicos e clínicas da rede credenciada Omint?</h3>

          <p>
            A busca de rede pode ser feita pelo App ou Site Omint. O associado pode pesquisar por especialidade, nome,
            localização, distância, facilidades, idioma, teleconsulta, agendamento online e outros filtros disponíveis.
          </p>

          <h3>A Omint oferece busca de rede com Inteligência Artificial?</h3>

          <p>
            Sim. A Omint oferece busca de rede com apoio de Inteligência Artificial. O associado pode escrever, falar ou
            enviar a imagem de um pedido médico para receber apoio na localização de serviços e profissionais
            relacionados à sua necessidade.
          </p>

          <h3>Posso solicitar reembolso pelo App Omint?</h3>

          <p>
            Sim. O associado pode solicitar reembolso pelos canais digitais, enviar documentos, acompanhar o andamento e
            consultar detalhes da análise e do cálculo.
          </p>

          <h3>Posso acompanhar autorizações pelo App ou Site?</h3>

          <p>
            Sim. Autorizações prévias podem ser acompanhadas pelos canais digitais Omint, com visualização de status,
            detalhes da solicitação e histórico.
          </p>

          <h3>Como funciona o WhatsApp Omint?</h3>

          <p>
            O WhatsApp Omint permite receber alertas, acompanhar solicitações, acessar serviços digitais e contar com
            atendimento apoiado por Inteligência Artificial e atendimento humano quando necessário.
          </p>

          <h3>A Omint oferece teleconsulta?</h3>

          <p>
            Sim. Pelo Dr. Omint, o associado pode agendar e realizar consultas por teleatendimento, conforme
            disponibilidade do serviço e condições do plano.
          </p>

          <h3>Posso compartilhar minhas informações com familiares?</h3>

          <p>
            Sim. A Omint permite que o próprio associado defina quais informações deseja compartilhar com pessoas do
            grupo familiar ou terceiros autorizados, preservando a privacidade e o controle sobre seus dados.
          </p>

          <h3>A Omint protege minhas informações pessoais e de saúde?</h3>

          <p>
            Sim. A experiência digital Omint utiliza login individual, validações de identidade, biometria facial,
            gestão de permissões, rastreabilidade e acesso restrito às informações pessoais, médicas e financeiras.
          </p>

          <h3>O atendimento humano continua disponível?</h3>

          <p>
            Sim. Os canais digitais facilitam a jornada, mas a equipe de Atendimento e Concierge Omint continua
            disponível para apoiar o associado em dúvidas, orientações e situações que exigem cuidado humano.
          </p>

          <hr />

          <h2>Resumo dos principais serviços digitais Omint</h2>

          <table>
            <thead>
              <tr>
                <th>Serviço digital</th>
                <th>O que permite fazer</th>
                <th>Principal benefício</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>App Omint</td>
                <td>Acessar serviços do plano pelo celular</td>
                <td>Autonomia e praticidade</td>
              </tr>
              <tr>
                <td>Site Omint</td>
                <td>Utilizar serviços digitais pela web</td>
                <td>Conveniência e navegação ampliada</td>
              </tr>
              <tr>
                <td>WhatsApp Omint</td>
                <td>Receber alertas e acessar serviços pelo WhatsApp</td>
                <td>Proximidade e agilidade</td>
              </tr>
              <tr>
                <td>Credencial digital e token</td>
                <td>Apresentar identificação na rede credenciada</td>
                <td>Segurança no atendimento</td>
              </tr>
              <tr>
                <td>Busca de rede</td>
                <td>Encontrar médicos, clínicas e hospitais</td>
                <td>Facilidade para escolher prestadores</td>
              </tr>
              <tr>
                <td>Busca com IA</td>
                <td>Pesquisar rede por texto, voz ou imagem de pedido médico</td>
                <td>Mais rapidez e orientação</td>
              </tr>
              <tr>
                <td>Reembolso digital</td>
                <td>Solicitar e acompanhar reembolsos</td>
                <td>Menos burocracia e mais transparência</td>
              </tr>
              <tr>
                <td>Autorizações</td>
                <td>Solicitar e acompanhar autorizações prévias</td>
                <td>Previsibilidade do processo</td>
              </tr>
              <tr>
                <td>Teleatendimento</td>
                <td>Agendar e realizar consultas digitais</td>
                <td>Acesso ao cuidado sem deslocamento</td>
              </tr>
              <tr>
                <td>Programas de saúde</td>
                <td>Interagir com equipes de programas de cuidado</td>
                <td>Continuidade e acompanhamento</td>
              </tr>
              <tr>
                <td>Coparticipação</td>
                <td>Simular e consultar valores e extratos</td>
                <td>Controle financeiro</td>
              </tr>
              <tr>
                <td>Gestão de acesso</td>
                <td>Definir permissões para familiares e terceiros</td>
                <td>Privacidade e personalização</td>
              </tr>
              <tr>
                <td>Acessibilidade</td>
                <td>Usar recursos como Libras e ajustes de navegação</td>
                <td>Inclusão e autonomia</td>
              </tr>
              <tr>
                <td>Documentos digitais</td>
                <td>Consultar manuais, informes, faturas e cartas</td>
                <td>Acesso rápido a informações importantes</td>
              </tr>
            </tbody>
          </table>

          <hr />

          <h2>Mensagem final</h2>

          <p>
            Na Omint, os canais digitais foram pensados para tornar a experiência do associado mais simples, segura e
            integrada.
          </p>

          <p>
            O App, o Site e o WhatsApp ajudam a resolver solicitações com mais autonomia, acompanhar processos com
            transparência e acessar serviços importantes do plano de saúde com poucos cliques.
          </p>

          <p>
            Mas a tecnologia é apenas uma parte da experiência. O cuidado Omint também está nas pessoas que orientam,
            acolhem e apoiam o associado quando ele mais precisa.
          </p>

          <p>
            Por isso, os serviços digitais Omint combinam inovação, segurança e atendimento humano para entregar uma
            jornada de cuidado moderna, personalizada e confiável.
          </p>
        </div>
      </article>
    </main>

    <footer class="footer reveal delay-3">
      <div class="footer-card">Tecnologia para simplificar. Pessoas para cuidar. Processos para garantir.</div>
    </footer>
  </div>
</template>

<script>
import digitalServicesSeoMixin from "./seoMixin";

export default {
  name: "DigitalServices",
  mixins: [digitalServicesSeoMixin],
  mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped>
.digital-services-page {
  --omint-green-900: #111f56;
  --omint-green-800: #172972;
  --omint-green-700: #223a99;
  --omint-green-600: #2f49ba;
  --omint-mint-200: #dfe5ff;
  --omint-mint-100: #eef2ff;
  --omint-sand-100: #f5f7ff;
  --omint-ink: #1a2342;
  --omint-muted: #4d587d;
  --omint-line: #d7def6;
  --omint-surface: #ffffff;
  --shadow-soft: 0 12px 30px rgba(23, 41, 114, 0.1);
  --shadow-card: 0 16px 40px rgba(23, 41, 114, 0.2);
  --radius-lg: 24px;
  --radius-md: 14px;
  --radius-sm: 10px;
  --max-width: 1100px;
}

.digital-services-page,
.digital-services-page * {
  box-sizing: border-box;
}

.digital-services-page {
  margin: 0;
  padding: 0;
  display: flow-root;
  color: var(--omint-ink);
  background: radial-gradient(circle at 8% 4%, rgba(47, 73, 186, 0.16), transparent 38%),
    radial-gradient(circle at 95% 0%, rgba(23, 41, 114, 0.14), transparent 34%),
    linear-gradient(180deg, #eff3ff 0%, #f3f6ff 34%, #f6f8ff 100%);
  font-family: "Work Sans", "Segoe UI", Tahoma, sans-serif;
  line-height: 1.65;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  scroll-behavior: smooth;
  min-height: 100vh;
}

.ambient-shape {
  position: fixed;
  border-radius: 999px;
  filter: blur(2px);
  pointer-events: none;
  z-index: -1;
}

.shape-a {
  width: 340px;
  height: 340px;
  right: -120px;
  top: 180px;
  background: radial-gradient(circle at 30% 30%, rgba(47, 73, 186, 0.34), rgba(47, 73, 186, 0));
}

.shape-b {
  width: 300px;
  height: 300px;
  left: -120px;
  bottom: 120px;
  background: radial-gradient(circle at 60% 30%, rgba(23, 41, 114, 0.28), rgba(23, 41, 114, 0));
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  backdrop-filter: blur(10px);
  background: rgba(246, 248, 255, 0.84);
  border-bottom: 1px solid rgba(23, 41, 114, 0.12);
}

.topbar-inner {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
}

.brand img {
  width: 122px;
  height: auto;
  display: block;
}

.brand span {
  letter-spacing: 0.02em;
  font-size: 0.86rem;
  color: var(--omint-muted);
  text-transform: uppercase;
  font-weight: 600;
}

.hero {
  max-width: var(--max-width);
  margin: 36px auto 22px;
  padding: 0 20px;
}

.hero-card {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-lg);
  background: linear-gradient(
    160deg,
    rgba(17, 31, 86, 0.97) 0%,
    rgba(23, 41, 114, 0.96) 44%,
    rgba(34, 58, 153, 0.95) 100%
  );
  color: #f5fcf9;
  padding: clamp(24px, 4.3vw, 48px);
  box-shadow: var(--shadow-card);
  isolation: isolate;
}

.hero-card::before,
.hero-card::after {
  content: "";
  position: absolute;
  border-radius: 999px;
  opacity: 0.24;
  z-index: -1;
}

.hero-card::before {
  width: 420px;
  height: 420px;
  right: -130px;
  top: -150px;
  background: radial-gradient(circle, rgba(215, 242, 234, 0.9) 0%, rgba(215, 242, 234, 0) 68%);
}

.hero-card::after {
  width: 280px;
  height: 280px;
  left: -70px;
  bottom: -130px;
  background: radial-gradient(circle, rgba(236, 248, 244, 0.8) 0%, rgba(236, 248, 244, 0) 67%);
}

.hero h1 {
  font-family: "Source Serif 4", Georgia, serif;
  margin: 0;
  font-weight: 700;
  font-size: clamp(2rem, 4.8vw, 3.25rem);
  line-height: 1.08;
  letter-spacing: 0.01em;
  max-width: 16ch;
}

.hero p {
  margin: 16px 0 0 !important;
  max-width: 70ch;
  color: rgba(245, 252, 249, 0.92);
  font-size: clamp(1rem, 2.1vw, 1.15rem);
}

.hero-meta {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.pill {
  padding: 9px 14px;
  border-radius: 999px;
  border: 1px solid rgba(237, 250, 245, 0.3);
  background: rgba(237, 250, 245, 0.12);
  font-size: 0.86rem;
  color: #e8f7f1;
  font-weight: 500;
}

.content-wrap {
  max-width: var(--max-width);
  margin: 0 auto 60px;
  padding: 0 20px;
}

.content-card {
  background: var(--omint-surface);
  border: 1px solid var(--omint-line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  overflow: hidden;
}

.content-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--omint-line);
  background: linear-gradient(180deg, #fbfffd, #f4fbf8);
  color: var(--omint-muted);
  font-size: 0.92rem;
}

.prose {
  padding: clamp(22px, 4vw, 46px);
}

.prose > :first-child {
  margin-top: 0 !important;
}

.prose h1,
.prose h2,
.prose h3 {
  color: var(--omint-green-900);
  letter-spacing: 0.01em;
}

.prose h1 {
  font-family: "Source Serif 4", Georgia, serif;
  font-weight: 700;
  font-size: clamp(1.9rem, 3.8vw, 2.5rem);
  line-height: 1.2;
  margin: 0 0 18px;
}

.prose h2 {
  font-family: "Source Serif 4", Georgia, serif;
  font-weight: 700;
  font-size: clamp(1.4rem, 2.8vw, 1.9rem);
  line-height: 1.25;
  margin-top: 2.2rem !important;
  margin-bottom: 0.8rem;
  padding-left: 14px;
  border-left: 4px solid var(--omint-green-600);
}

.prose h3 {
  font-size: 1.15rem;
  margin-top: 1.4rem !important;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.prose p {
  margin: 0.78rem 0 !important;
  color: #2a3936;
}

.prose ul,
.prose ol {
  margin: 0.8rem 0 1rem;
  padding-left: 1.25rem;
}

.prose li {
  margin: 0.35rem 0;
  color: #2d403c;
  padding-left: 0.2rem;
}

.prose strong {
  color: #133a33;
}

.prose hr {
  border: 0;
  border-top: 1px solid var(--omint-line);
  margin: 1.9rem 0;
}

.prose blockquote {
  margin: 1.1rem 0;
  padding: 0.95rem 1rem 0.95rem 1.1rem;
  border-left: 4px solid var(--omint-green-600);
  background: var(--omint-mint-100);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  color: #24554d;
}

.prose table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.2rem 0;
  overflow: hidden;
  border-radius: var(--radius-sm);
  border: 1px solid var(--omint-line);
  font-size: 0.94rem;
}

.prose thead {
  background: #edf7f3;
}

.prose th,
.prose td {
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid #e2eeea;
  padding: 11px 12px;
}

.prose tr:last-child td {
  border-bottom: 0;
}

.footer {
  max-width: var(--max-width);
  margin: 0 auto 36px;
  padding: 0 20px;
}

.footer-card {
  border-radius: var(--radius-md);
  background: linear-gradient(120deg, #111f56, #223a99);
  color: #effbf6;
  padding: 18px 20px;
  font-size: 0.92rem;
  box-shadow: var(--shadow-soft);
}

.reveal {
  opacity: 0;
  transform: translateY(12px);
  animation: rise 0.6s ease forwards;
}

.delay-1 {
  animation-delay: 0.06s;
}

.delay-2 {
  animation-delay: 0.15s;
}

.delay-3 {
  animation-delay: 0.24s;
}

@keyframes rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 780px) {
  .topbar-inner {
    padding-inline: 14px;
  }

  .hero,
  .content-wrap,
  .footer {
    padding-inline: 14px;
  }

  .hero {
    margin-top: 20px;
  }

  .hero-card {
    border-radius: 16px;
  }

  .content-card {
    border-radius: 16px;
  }

  .prose table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
</style>
